module.exports = __webpack_public_path__ + "static/img/3-1.e3c4d87.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/3-1.png
// module id = cNYH
// module chunks = 0